export default {
  setSession({ commit }, payload) {
    commit("setSession", payload);
  },

  setConsorcio({ commit }, payload) {
    commit("setConsorcio", payload);
  },

  setFinanciamento({ commit }, payload) {
    commit("setFinanciamento", payload);
  },

  setTrend({ commit }, payload) {
    commit("setTrend", payload);
  },

  setFilter({ commit }, payload) {
    commit("setFilter", payload);
  },

  setLeads({ commit }, payload) {
    commit("setLeads", payload);
  },

  setLeadFromFirestore({ commit }, payload) {
    commit("setLeadFromFirestore", payload);
  }
};
